import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  wrapper: {
    background: theme.palette.white.efesBackgroundLight,
    borderRadius: 9,
  },
  invoiceCard: {
    padding: 15,
    marginTop: 20,
  },

  invoiceCardRow: {
    marginBottom: 15,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    textTransform: 'uppercase',
  },

  label: {
    color: theme.palette.gray.efesBorder,
  },

  seeMore: {
    width: '100%',
    height: 30,
    backgroundColor: '#F2F3F4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderBottomLeftRadius: 9,
    borderBottomRightRadius: 9,
  },

  arrowIcon: {
    color: theme.palette.gray.efesBorder,
    transition: 'all 0.2s ease',
    transformOrigin: 'center',
    width: 30,
    height: 30,
  },

  open: {
    transform: 'rotate(180deg)',
  },
}));

export default useStyles;
